import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取格式化课程地点列表
 * @param {*} params 
 */
export function getFormatTeachingpoint(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/teachingpoint/format_teachingpoint',
        method: 'get',
        params: param
    })
}

/**
 * 获取教学分点列表
 * @param {*} params 
 */
export function getTeachingpoint(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/teachingpoint/getteachingpoint',
        method: 'post',
        data: data
    })
}

/**
 * 删除教学分点
 * @param {*} params 
 */
export function deleteTeachingpoint(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/teachingpoint/deleteTeachingpoint',
        method: 'post',
        data: data
    })
}

/**
 * 删除教学分点
 * @param {*} params 
 */
export function addTeachingpoint(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/teachingpoint/addTeachingpoint',
        method: 'post',
        data: data
    })
}

/**
 * 修改教学分点
 * @param {*} params 
 */
export function editTeachingpoint(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/teachingpoint/editTeachingpoint',
        method: 'post',
        data: data
    })
}